module.exports = __webpack_public_path__ + "img/goldregen-2020-004.c4756836.jpg";